module.exports = __webpack_public_path__ + "static/img/14001003.ed391b9d.png";